import React, { useEffect } from "react";
import { useAudio } from "../Contexts/AudiosContext";
import RabbitLyrics from "rabbit-lyrics";
import "../Styles/AudioPlayer.css";
import lyricsnotfound from "../Images/lyricsnotfound.png";
import Loading from "./Loading";

const AudioLyrics = () => {
  const { currentAudio, message, lyricsText, refAudio } = useAudio();
  const refLrc = React.useRef<any>(null);
  const [isInitialized, setIsInitialized] = React.useState<boolean>(false);

  useEffect(() => {
    // Reset initialized state on audio or lyrics change
    setIsInitialized(false);

    if (!currentAudio || !lyricsText) {
      console.log("[AudioLyrics] skipping init - no currentAudio or lyricsText", { currentAudio, lyricsText });
      return;
    }
    console.log("[AudioLyrics] attempting init", { id: currentAudio?.id, lyricsLength: lyricsText?.length });

    let mounted = true;
    const audioElId = `audio-${currentAudio.id}`;

    // Helper that tries to initialize RabbitLyrics when audio element exists
    const init = () => {
      if (!mounted) return;
      // Prefer the central player audio ref if available, otherwise fall back
      // to locating the element by id in the document.
      const audioEl = (refAudio && refAudio.current) || document.getElementById(audioElId) as any;
      if (!audioEl || !refLrc.current) {
        console.log(`[AudioLyrics] audio element or ref not ready for ${audioElId}`);
        return false;
      }

      try {
        // Debug: inspect lyricsText before inserting so we can tell whether
        // the content contains HTML markup or is plain text (which would
        // render as a paragraph).
        const text = lyricsText || "";
        const hasHtml = /<[^>]+>/.test(text);
        console.debug("[AudioLyrics] initializing RabbitLyrics", { audioElId, length: text.length, hasHtml, sample: text.slice(0, 200) });

        // Clear any existing content to force RabbitLyrics to render fresh
        refLrc.current.innerHTML = text;
        new RabbitLyrics(refLrc.current, audioEl);
        setIsInitialized(true);
        console.log(`[AudioLyrics] RabbitLyrics initialized for audio ${audioElId}`);
        return true;
      } catch (err) {
        console.error("[AudioLyrics] RabbitLyrics init error", err);
        return false;
      }
    };

    // If audio element not mounted yet, retry a few times with short delay
    let retries = 0;
    const maxRetries = 20;
    const retryInterval = 100; // ms

    if (!init()) {
      const t = setInterval(() => {
        retries++;
        console.log("[AudioLyrics] retrying init", { retries, audioElId });
        if (init() || retries >= maxRetries) {
          clearInterval(t);
        }
      }, retryInterval);
      return () => {
        mounted = false;
        clearInterval(t);
      };
    }
    return () => (mounted = false);
  }, [currentAudio, lyricsText, refAudio]);

  return (
    <div style={{ marginTop: "-40px" }}>
      <div className="header" style={{ margin: "0 0 0 12%" }}>
        <h1 style={{ fontSize: 25, color: "#ff9c00", margin: "0 0 0 -15%", fontWeight: "normal" }}>
          {currentAudio?.name != null && currentAudio.name.length > 15
            ? currentAudio.name.slice(0, 100)
            : currentAudio?.name}
        </h1>
      </div>
      <div>
        {currentAudio?.lyricsHash != null ? (
          <div className="" style={{ height: "100%" }}>
            <div style={{ position: "relative" }}>
              <div
                ref={refLrc}
                key={currentAudio?.id}
                className="lyrics"
                style={{
                  fontSize: "25px",
                  padding: "10px",
                  fontFamily: "ChanakyaUni",
                }}
              />
              {/* loading overlay shown while RabbitLyrics initializes */}
              {!isInitialized ? (
                <div style={{ position: "absolute", inset: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <Loading />
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <div
            style={{
              // width: "85%",
              // float: "left",
              textAlign: "center",
              // marginLeft: "8%",
            }}
          >
            <img
              alt="lyricsnotfound"
              src={lyricsnotfound}
              className="lyricsnotfoundstyle"
            ></img>
          </div>
        )}
        <div
          style={{
            textAlign: "center",
            zIndex: 1,
            position: "absolute",
            // display: "flex",
            // top: "750px",
            top: "85%",
            // left: "2%",
            backgroundColor: "#ffa820",
            borderRadius: "10px",
          }}
        >
          <p
            style={{
              fontSize: "22px",
              fontFamily: "ChanakyaUni",
              margin: "0px 10px 0 5px",
              // paddingTop: "2%",
              color: "#fff",
              // borderBottom: "2px solid #FE8B35"
            }}
          >
            {message}
          </p>
        </div>
      </div>
    </div >
  );
};
export default AudioLyrics;
